import { hot } from 'react-hot-loader/root';
import React from 'react';
import View from './View';
import ReactDOM from 'react-dom';

const Login = hot(class Login extends React.Component {
	render() {
		return <View />;
	}
});

ReactDOM.render(<Login />, document.getElementById('application'));